import React from "react";
import { trackError } from "../utils/errorTracker";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    trackError({
      type: "js_error",
      message: error.message,
      stack: error.stack,
      component: errorInfo.componentStack || "",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="button-signature-modal-container">
          <div className="button-signature-modal">
            <p>Une erreur est survenue. Veuillez recharger la page.</p>
            <button
              onClick={() => window.location.reload()}
              style={{
                marginTop: "1em",
                padding: "0.6em 1.2em",
                backgroundColor: "#F96332",
                color: "#fff",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
                fontSize: "0.9em",
              }}
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
